module.exports = __webpack_public_path__ + "img/product_89.cad0fce.webp";